module.exports = __webpack_public_path__ + "img/12.dc6a04f0.png";